module.exports = __webpack_public_path__ + "static/njideka-94efe22a855053e8dfb82cc56a1d71e6.png";